package com.milta.feature.team.data.remote.dto

import kotlinx.serialization.Serializable

/** Body of POST /enterprises/{enterpriseId}/team/link (MIL-49). */
@Serializable
data class LinkDriverRequest(val code: String)
